import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../firebase.config";
const toNum = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const num = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(num) ? num : 0;
};
export const fetchDashboardData = async (auditId) => {
  if (!auditId) {
    throw new Error("Audit ID is required to fetch dashboard data");
  }

  const formBRef = doc(db, "auditReports", auditId, "form_b", "main");
  const formCRef = doc(db, "auditReports", auditId, "form_c", "main");

  const [formBSnap, formCSnap] = await Promise.all([
    getDoc(formBRef),
    getDoc(formCRef),
  ]);

  const formB = formBSnap.exists() ? formBSnap.data() : {};
  const formC = formCSnap.exists() ? formCSnap.data() : {};

  const sourceRows = formB.sourceRows || [];
  const pfcRows = formB.pfcRows || [];
  const measRows = formB.measRows || [];

  const ghgManual = formC.ghgBalance?.manual || {};
  const ghgFromSheet = formC.ghgBalance?.fromSheet || {};

  const directEmissions =
    toNum(ghgManual.direct) ||
    toNum(ghgFromSheet.direct) ||
    sourceRows.reduce((sum, row) => sum + toNum(row.co2eFossil), 0) +
      pfcRows.reduce((sum, row) => sum + toNum(row.co2eFossil), 0) +
      measRows.reduce((sum, row) => sum + toNum(row.co2eFossil), 0);

  const indirectEmissions =
    toNum(ghgManual.indirect) || toNum(ghgFromSheet.indirect);

  const totalEmissions =
    toNum(ghgManual.total) ||
    toNum(ghgFromSheet.total) ||
    directEmissions + indirectEmissions;

  const allRows = [
    ...sourceRows.map((row, index) => ({
      id: `D${String(index + 1).padStart(3, "0")}`,
      hotspotId: `HS${String(index + 1).padStart(3, "0")}`,
      source: row.sourceName || row.processId || "Calculation-based source",
      category: row.fuelType || row.method || "Source Stream",
      sector: row.processId || "Direct Emissions",
      value: toNum(row.co2eFossil),
      type: "Direct",
      risk: toNum(row.co2eFossil) > 10000 ? "High" : toNum(row.co2eFossil) > 5000 ? "Medium" : "Low",
      cbam: "Yes",
    })),

    ...pfcRows.map((row, index) => ({
      id: `P${String(index + 1).padStart(3, "0")}`,
      hotspotId: `HS-P${String(index + 1).padStart(3, "0")}`,
      source: row.technologyType || "PFC emissions",
      category: "PFC",
      sector: "Aluminium",
      value: toNum(row.co2eFossil),
      type: "Direct",
      risk: toNum(row.co2eFossil) > 10000 ? "High" : toNum(row.co2eFossil) > 5000 ? "Medium" : "Low",
      cbam: "Yes",
    })),

    ...measRows.map((row, index) => ({
      id: `M${String(index + 1).padStart(3, "0")}`,
      hotspotId: `HS-M${String(index + 1).padStart(3, "0")}`,
      source: row.name || "Measurement-based source",
      category: row.ghgType || "Measurement",
      sector: "Measurement-based",
      value: toNum(row.co2eFossil),
      type: "Direct",
      risk: toNum(row.co2eFossil) > 10000 ? "High" : toNum(row.co2eFossil) > 5000 ? "Medium" : "Low",
      cbam: "Yes",
    })),
  ].filter((row) => row.value > 0);

  return {
    meta: {
      period: "FY 2026",
      unit: "tCO₂e",
    },

    settings: {
      currency: "INR",
      defaultConversionRate: 76,
    },

    overview: {
      metrics: {
        totalEmissions,
        directEmissions,
        indirectEmissions,
        sourcesCount: allRows.length,
      },
    },

    emissions: {
      sources: allRows,
    },

    dashboard: {
      hotspots: allRows,
      recommendations: [],
      auditProgress: {},
      reports: [],
    },
  };
};